import { render, staticRenderFns } from "./InfoLink.vue?vue&type=template&id=8c35d22a&"
import script from "./InfoLink.vue?vue&type=script&lang=js&"
export * from "./InfoLink.vue?vue&type=script&lang=js&"
import style0 from "./InfoLink.vue?vue&type=style&index=0&id=8c35d22a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports